import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { Droplet } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const ProfilesStrategiesTabHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const { account } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'profilesStrategies.navigation.listFeedStrategies' }),
          to: '/profiles-strategies/feed-strategies',
        },
        {
          hasAccess: true,
          label: intl.formatMessage({ id: 'profilesStrategies.navigation.listProfiles' }),
          to: '/profiles-strategies/profiles',
        },
        {
          hasAccess: account.company?.features.hasPlanningPrognosisManageMarketProfiles,
          label: intl.formatMessage({ id: 'profilesStrategies.navigation.editMarketProfiles' }),
          to: '/profiles-strategies/market',
        },
        {
          hasAccess: account.company?.features.hasPlanningPrognosisManageCompanyOrSiteProfiles,
          label: intl.formatMessage({ id: 'profilesStrategies.navigation.editSiteProfiles' }),
          to: '/profiles-strategies/site',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<Droplet size={25} color={'white'} />}
    />
  );
};

export default React.memo(ProfilesStrategiesTabHeader);
